import { createUseStyles } from 'react-jss';

const phone = '@media (max-width: 480px)';

export const useStyles = createUseStyles({
  page: {
    minHeight: '100dvh',
    padding: '32px 40px',
    paddingTop: 'calc(32px + env(safe-area-inset-top, 0px))',
    paddingRight: 'calc(40px + env(safe-area-inset-right, 0px))',
    paddingBottom: 'calc(32px + env(safe-area-inset-bottom, 0px))',
    paddingLeft: 'calc(40px + env(safe-area-inset-left, 0px))',
    background: '#f4f6f8',
    boxSizing: 'border-box',
    [phone]: {
      paddingTop: 'calc(12px + env(safe-area-inset-top, 0px))',
      paddingRight: 'calc(12px + env(safe-area-inset-right, 0px))',
      paddingBottom: 'calc(16px + env(safe-area-inset-bottom, 0px))',
      paddingLeft: 'calc(12px + env(safe-area-inset-left, 0px))',
    },
  },
  header: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: 16,
    marginBottom: 16,
    [phone]: {
      flexDirection: 'column',
      alignItems: 'stretch',
      gap: 12,
      marginBottom: 12,
    },
  },
  titleBlock: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },
  headerActions: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    gap: 12,
    [phone]: {
      alignItems: 'stretch',
    },
  },
  profileButton: {
    width: 44,
    height: 44,
    border: '1px solid rgba(0, 0, 0, 0.23)',
    backgroundColor: '#fff',
    color: '#374151',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
      borderColor: 'rgba(0, 0, 0, 0.4)',
    },
    [phone]: {
      alignSelf: 'flex-end',
    },
  },
  weekNav: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    justifyContent: 'flex-end',
    gap: 12,
    [phone]: {
      justifyContent: 'stretch',
      '& > button': {
        flex: 1,
      },
    },
  },
  weekControls: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: 12,
    marginTop: 16,
    marginBottom: 8,
    [phone]: {
      justifyContent: 'stretch',
      '& > button': {
        flex: 1,
      },
    },
  },
  swapHint: {
    marginBottom: 16,
  },
  historyPaper: {
    marginTop: 24,
    padding: '16px 20px 8px',
    overflowX: 'auto',
    WebkitOverflowScrolling: 'touch',
    [phone]: {
      marginTop: 16,
      padding: '12px 12px 8px',
    },
  },
  historyTable: {
    width: '100%',
    marginTop: 8,
    borderCollapse: 'collapse',
    tableLayout: 'fixed',
    minWidth: 720,
  },
  historyHead: {
    padding: '4px 8px 8px',
    textAlign: 'left',
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: '0.04em',
    textTransform: 'uppercase',
    color: '#6b7280',
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    whiteSpace: 'nowrap',
  },
  historyRow: {
    '&:hover td': {
      background: 'rgba(25, 118, 210, 0.04)',
    },
    '&:last-child td': {
      borderBottom: 'none',
    },
  },
  historyTime: {
    width: 100,
    padding: '6px 12px 6px 0',
    color: '#6b7280',
    fontSize: 13,
    whiteSpace: 'nowrap',
    borderBottom: '1px solid rgba(0, 0, 0, 0.08)',
  },
  historyWho: {
    width: '14%',
    padding: '6px 8px',
    fontWeight: 600,
    fontSize: 13,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    borderBottom: '1px solid rgba(0, 0, 0, 0.08)',
  },
  historyHours: {
    width: '14%',
    padding: '6px 8px',
    fontSize: 13,
    fontWeight: 600,
    color: '#6b7280',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    borderBottom: '1px solid rgba(0, 0, 0, 0.08)',
  },
  historyHoursAfter: {
    width: '14%',
    padding: '6px 8px',
    fontSize: 13,
    fontWeight: 600,
    color: '#1976d2',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    borderBottom: '1px solid rgba(0, 0, 0, 0.08)',
  },
  historySwap: {
    width: 28,
    padding: '6px 0',
    textAlign: 'center',
    color: '#9ca3af',
    fontSize: 14,
    borderBottom: '1px solid rgba(0, 0, 0, 0.08)',
  },
  historyAction: {
    width: 64,
    padding: '2px 0 2px 8px',
    textAlign: 'right',
    borderBottom: '1px solid rgba(0, 0, 0, 0.08)',
  },
  tablePaper: {
    overflow: 'auto',
    WebkitOverflowScrolling: 'touch',
    [phone]: {
      marginLeft: -12,
      marginRight: -12,
      borderRadius: 0,
    },
  },
  dayHeader: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 2,
    minWidth: 120,
    [phone]: {
      minWidth: 92,
    },
  },
  personCell: {
    fontWeight: 600,
    whiteSpace: 'nowrap',
    width: 180,
    verticalAlign: 'middle',
    position: 'sticky',
    left: 0,
    zIndex: 2,
    backgroundColor: '#fff',
    [phone]: {
      width: 96,
      minWidth: 96,
      padding: '8px 10px',
    },
  },
  personName: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  },
  remainingHours: {
    fontWeight: 500,
    fontSize: 12,
    color: '#6b7280',
  },
  remainingUnder: {
    color: '#d32f2f',
  },
  remainingOver: {
    color: '#2e7d32',
  },
  monthHeader: {
    borderLeft: '1px solid rgba(224, 224, 224, 1)',
    backgroundColor: 'rgba(25, 118, 210, 0.04)',
  },
  monthTotalCell: {
    fontWeight: 700,
    color: '#1976d2',
    whiteSpace: 'nowrap',
    borderLeft: '1px solid rgba(224, 224, 224, 1)',
    backgroundColor: 'rgba(25, 118, 210, 0.04)',
  },
  shiftCell: {
    height: 64,
    padding: 4,
    borderLeft: '1px solid rgba(224, 224, 224, 1)',
    verticalAlign: 'middle',
    [phone]: {
      height: 56,
      padding: 2,
    },
  },
  todayColumn: {
    backgroundColor: 'rgba(25, 118, 210, 0.08)',
  },
  weekendColumn: {
    backgroundColor: 'rgba(0, 0, 0, 0.03)',
  },
});
